import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../Components/NavigationLayout";
import Edit from "./Edit";
import MainEdit from "./MainEdit";

const UsefulLinks = () => {
  return (
    <NavigationLayout>
      <Router history={history}>
        <Switch>
          <Route exact path="/admin/useful-links" component={List} />
          <Route path="/admin/useful-links/new" component={Add} />
          <Route path="/admin/useful-links/:id" component={MainEdit} />
        </Switch>
      </Router>
    </NavigationLayout>
  );
};
export default UsefulLinks;
